export const getInitialScale = () => {
  if (typeof window !== 'undefined' && window.visualViewport) {
    return window.visualViewport.scale;
  }

  return document.documentElement.clientWidth / window.innerWidth;
};

export const subscribeVisualViewportChange = (
  handleScale: (scale: number) => void
) => {
  const visualViewport = window.visualViewport as VisualViewport;
  const onResizeOrScroll = () => handleScale(visualViewport.scale);

  visualViewport.addEventListener('resize', onResizeOrScroll);
  visualViewport.addEventListener('scroll', onResizeOrScroll);

  onResizeOrScroll();

  const cleanup = () => {
    visualViewport.removeEventListener('resize', onResizeOrScroll);
    visualViewport.removeEventListener('scroll', onResizeOrScroll);
  };

  return cleanup;
};

export const subscribeFallbackZoom = (handleScale: (scale: number) => void) => {
  const onResize = () => {
    const ratio = document.documentElement.clientWidth / window.innerWidth;
    handleScale(ratio);
  };

  window.addEventListener('resize', onResize);

  onResize();

  return () => window.removeEventListener('resize', onResize);
};

export const createHiddenSingleLetterElement = (): HTMLDivElement => {
  const hiddenElement = document.createElement('div');
  hiddenElement.style.cssText =
    'position:absolute;top:0;right:0;visibility:hidden;font-size:medium;line-height:normal;margin:0;padding:0;';
  hiddenElement.textContent = 'A';
  hiddenElement.setAttribute('data-testid', 'font-zoom-hidden-element');
  document.body.appendChild(hiddenElement);

  return hiddenElement;
};

export const createHiddenFullscreenElement = (): HTMLDivElement => {
  const hiddenElement = document.createElement('div');
  hiddenElement.style.cssText =
    'position:absolute;top:0;right:0;visibility:hidden;font-size:medium;line-height:normal;margin:0;padding:0;width:100vw';
  hiddenElement.setAttribute('data-testid', 'pinch-zoom-hidden-element');
  document.body.appendChild(hiddenElement);

  return hiddenElement;
};
